export default {
	pageSize: 50,

	appRoot: 'http://localhost:3000',

	grecaptchaKey: '6LdasXUUAAAAAH_fV2av5Lkr3Cp8NZjrkaL_Qp7a',

	//apiRoot: 'http://130.208.108.18:8800'
	apiRoot: 'https://nyyrdi.arnastofnun.is/d'
}



// WEBPACK FOOTER //
// ./src/config.js